/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type KycCheckStatus = typeof KycCheckStatus[keyof typeof KycCheckStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KycCheckStatus = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  INCONCLUSIVE: 'INCONCLUSIVE',
} as const;
